import { SVGProps } from "react";

export const FactoryIcon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="M6 11.499 5 0.499023H2L1 11.499h5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill="none"
        d="M0.5 23.4991v-12h6v3l5 -3.18v3.411l6.018 -3.387v3.41l5.982 -3.434v12.18H0.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M17.518 14.7531v-1.41l-6.018 3.387v-3.411l-5 3.18v-3h-6v10h23v-10.18l-5.982 3.434v-2Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M1.54599 5.49902h3.908l-0.181 -2h-3.546l-0.181 2Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.5 18.499h12"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.5 20.499h12"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.5 23.4991v-12h6v3l5 -3.18v3.411l6.018 -3.387v3.41l5.982 -3.434v12.18H0.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 11.499 5 0.499023H2L1 11.499h5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.72699 3.49902h3.546"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.54599 5.49902h3.908"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
